import { render, staticRenderFns } from "./IconSvgCart.vue?vue&type=template&id=6c276b32&scoped=true&"
import script from "./IconSvgCart.vue?vue&type=script&lang=js&"
export * from "./IconSvgCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c276b32",
  null
  
)

export default component.exports